/**
 * @packageDocumentation
 * @module ScreenUtils
 * @category Shared
 */

export interface ScaledRectangle {
  /** Доля масштабирования */
  scale: number;
  /** Ширина после масштабирования */
  width: number;
  /** Высота после масштабирования */
  height: number;
}

/**
 * Рассчитывает масштабирование и размеры прямоугольника, чтобы он полностью вписался в прямоугольный контейнер.
 *
 * @param rectWidth Ширина контейнера
 * @param rectHeight Высота контейнера
 * @param targetWidth Ширина масштабируемого прямоугольника
 * @param targetHeight Высота масштабируемого прямоугольника
 * @returns
 */
export function scaleToContainRectangle(
  rectWidth: number,
  rectHeight: number,
  targetWidth: number,
  targetHeight: number,
): ScaledRectangle {
  if (!rectWidth || !rectHeight || !targetWidth || !targetHeight) {
    return { scale: 1, width: targetWidth, height: targetHeight };
  }

  const rectRatio = rectHeight / rectWidth;
  const targetRatio = targetHeight / targetWidth;
  const scale = targetRatio > rectRatio ? rectHeight / targetHeight : rectWidth / targetWidth;
  const width = targetWidth * scale;
  const height = targetHeight * scale;

  return { scale, width, height };
}

/**
 * Рассчитывает масштабирование и размеры прямоугольника, чтобы он вписался в прямоугольный контейнер без пустых областей (с возможной обрезкой).
 *
 * @param rectWidth Ширина контейнера
 * @param rectHeight Высота контейнера
 * @param targetWidth Ширина масштабируемого прямоугольника
 * @param targetHeight Высота масштабируемого прямоугольника
 * @returns
 */
export function scaleToCoverRectangle(
  rectWidth: number,
  rectHeight: number,
  targetWidth: number,
  targetHeight: number,
): ScaledRectangle {
  if (!rectWidth || !rectHeight || !targetWidth || !targetHeight) {
    return { scale: 1, width: targetWidth, height: targetHeight };
  }

  const rectRatio = rectHeight / rectWidth;
  const targetRatio = targetHeight / targetWidth;
  const scale = targetRatio < rectRatio ? rectHeight / targetHeight : rectWidth / targetWidth;
  const width = targetWidth * scale;
  const height = targetHeight * scale;

  return { scale, width, height };
}
